export default function (date: any) {
  if (date) {
    return new Date(date).toISOString().replace(/\..+/, "") || ""
  }
  return date
}
